import './Footer.css';

const Footer = () => {
  return (
    <footer className="app-footer">
      <div className="footer-socials">
        <a href="https://facebook.com/srkproduction" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
          <i className="fab fa-facebook-f" aria-hidden="true"></i>
        </a>
        <a href="https://twitter.com/srkproduction" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
          <i className="fab fa-twitter" aria-hidden="true"></i>
        </a>
        <a href="https://instagram.com/srkproduction" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
          <i className="fab fa-instagram" aria-hidden="true"></i>
        </a>
        <a href="https://linkedin.com/company/srkproduction" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
          <i className="fab fa-linkedin-in" aria-hidden="true"></i>
        </a>
      </div>
    </footer>
  );
};

export default Footer;
